import type { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthContext } from '../../auth/AuthContext';
import SigninForm from '../../components/form/SigninForm/SigninForm';
import MfaSmsForm from '../../components/form/MfaSmsForm/MfaSmsForm';
import SetupAppMFAForm from '../../components/form/SetupAppMFA/SetupAppMFAForm';
import { FormConfigContext } from '../../context/FormConfigContext';
import EnterAppMFACodeScreen from '../AppMFA/EnterAppMFACodeScreen';
import SetNewPasswordScreen from '../SetNewPassword/SetNewPasswordScreen';
import ResetPassword from './ResetPassword';

export default function HomebrewAccess({ children }: PropsWithChildren) {
  const { isAuthenticated, challengeName } = useAuthContext();
  const location = useLocation();
  const authPage =
    /^\/homebrew\/(signin|reset-password-email|reset-password|set-new-password|enter-app-mfa-code)\/?$/.test(
      location.pathname,
    );
  if (isAuthenticated) {
    return authPage ? <Navigate to="/homebrew" replace /> : <>{children}</>;
  }
  let heading = 'Sign in to Homebrew';
  let form = <SigninForm onSuccess={() => {}} />;
  if (location.pathname.includes('/reset-password')) {
    form = <ResetPassword />;
    heading = '';
  } else if (challengeName === 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED') {
    heading = 'Set your password';
    form = <SetNewPasswordScreen onSuccess={() => {}} />;
  } else if (challengeName === 'CONTINUE_SIGN_IN_WITH_TOTP_SETUP') {
    heading = 'Set up your authenticator';
    form = <SetupAppMFAForm />;
  } else if (challengeName === 'CONFIRM_SIGN_IN_WITH_TOTP_CODE') {
    heading = 'Enter your sign in code';
    form = <EnterAppMFACodeScreen />;
  } else if (challengeName === 'CONFIRM_SIGN_IN_WITH_SMS_CODE') {
    heading = 'Enter your sign in code';
    form = <MfaSmsForm onSuccess={() => {}} phonenumber="your registered number" />;
  }
  return (
    <FormConfigContext.Provider
      value={{
        config: {
          id: 'homebrew',
          formName: 'Homebrew',
          title: 'MacBook software',
          subTitle: '',
          live: false,
          sections: [],
        },
        tenant: 'homebrew',
        isLoading: false,
        error: null,
        portalComponent: null,
      }}
    >
      {heading && <h1 className="govuk-heading-l">{heading}</h1>}
      {form}
    </FormConfigContext.Provider>
  );
}
